import { useMediaQuery, useTheme } from "@mui/material";
import { useIsBehindFeatureFlag } from "./useFeatureFlag";

export const useIsMobile = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileEnabled = useIsBehindFeatureFlag("mobile_ui");
  return isSmallScreen && isMobileEnabled;
};
